import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  loading: "",
  list: [],
  byId: {},
};

const AccountsSlice = createSlice({
  name: "Accounts",
  initialState,
  reducers: {
    recieveAccounts(state, action) {
      state.list = action.payload
      state.byId = Object.fromEntries(action.payload.map(acc => [acc.id, acc]));
    },
  },
});

export const {
  recieveAccounts
} = AccountsSlice.actions

export default AccountsSlice.reducer;
